<template>
    <div id="manageClass">
        <div>
            <div class="Secondary">
            <nb-tags></nb-tags>
            </div>
        </div>
        <div class="allBodyDiv">
            <div style="margin-top: 15px">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/manageclass' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>成员管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <el-row class="manageClassBody" :gutter="20">
                <el-col :span="24" class="leftMember">
                    <el-card class="box-card ">
                        <div slot="header" class="clearfix">
                            <i class="blueI" style="left: 10px"></i>
                            <span class="cardHeader">班级成员（ {{filters.total}}人 ）</span>
                            <el-button class="fr" @click="addUserDialog=true" type="primary">批量添加</el-button>
                            <a :href="GLOBAL.url.apiPath + '/teachermanager/classGrade/exportUser?classId='+classId+'&token='+GLOBAL.userLoginInfo.token" target="view_window">
                                <el-button class="fr nbInfoBtn" style="margin-right: 20px">导出名单</el-button>
                            </a>
                        </div>
                        <div>
                            <el-table
                                    :data="classTable"
                                    border
                                    stripe
                                    show-header
                                    highlight-current-row
                                    row-class-name="graspTr"
                                    header-row-class-name="graspHeader"
                                    style="width: 100%">
                                <el-table-column
                                        prop="nickname"
                                        width="100"
                                        label="成员姓名">
                                </el-table-column>
                                <el-table-column
                                        prop="markName"
                                        width="100"
                                        label="备注名">
                                </el-table-column>
                                <el-table-column
                                        prop="username"
                                        label="登录账户">
                                </el-table-column>
                                <el-table-column
                                        prop="initPwd"
                                        width="100"
                                        label="初始密码">
                                </el-table-column>
                                <el-table-column
                                        prop="addTime"
                                        width="200"
                                        label="注册时间">
                                </el-table-column>
                                <el-table-column
                                        label="操作">
                                    <template slot-scope="props">
                                            <el-button
                                                    @click="$router.push({ path: '/memberdetails', query: { plan: props.row.userId,classId:classId,name: props.row.nickname,path:2}})"
                                                    class="specialBtn"
                                                    size="small">
                                                查看详情
                                            </el-button>
                                        <el-button
                                                @click="editNote(props.row.id)"
                                                class="specialBtn"
                                                size="small">
                                            修改备注
                                        </el-button>
                                        <el-button
                                                @click="deletUser(props.row)"
                                                class="specialBtn"
                                                size="small">
                                            移除
                                        </el-button>
                                      <!--上线合并断点-->
                                        <!--<el-button
                                                @click="getSchoolClass(props.row.student_id)"
                                                class="specialBtn"
                                                size="small">
                                            转班
                                        </el-button>-->
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-if="filters.total>0" style="margin-top:30px;text-align:right;">
                                <el-pagination
                                        @size-change="pageSizeChange"
                                        @current-change="pageChange"
                                        :current-page="currentPage4"
                                        :page-sizes="[5, 10, 20, 30]"
                                        :page-size="filters.pageSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="filters.total">
                                </el-pagination>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <el-dialog title="批量添加" :visible.sync="addUserDialog" custom-class="nbDialog" width="500px">
                <div style="width: 265px;margin: auto">
                    <div style="margin-top:20px;">
                        <div>
                            <span>权限容量：{{userData.schoolInfo.usedNum}}/{{userData.schoolInfo.limitStudentNum}}</span><br>
                            <span style="color:#d8d8d8;font-size:12px;">开通数量不能超出权限容量</span>
                        </div>
                        <el-form ref="ruleForm">
                            <el-form-item label="添加" prop="input">
                                <el-input style="width: 150px" v-model="input"></el-input>
                                <span>个学生账号</span>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer" style="text-align: center">
                <div>
                    <el-button @click="addUserDialog = false">取 消</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="addUser()">确 定</el-button>
                </div>
            </span>
            </el-dialog>

            <!--添加备注-->
            <el-dialog title="修改备注" :visible.sync="editNoteDialog" custom-class="nbDialog" width="500px">
                <div style="width: 375px;margin: auto">
                    <el-form>
                        <el-form-item label="备注名称" prop="name" label-width="80px">
                            <el-input style="width:280px;" v-model="markname" placeholder="请输入备注名称"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer" style="text-align: center">
                <div>
                    <el-button @click="editNoteDialog = false">取 消</el-button>
                    <el-button type="primary" @click="editNote(-1)" :loading="editNoteLoading">确 定</el-button>
                </div>
            </span>
            </el-dialog>

            <el-dialog title="转班" :visible.sync="changeClassDialog" custom-class="nbDialog" width="500px">
                <div style="width:300px;margin:auto">
                    将该学生转移至其他班级 <br>
                    转至班级：
                    <el-select v-model="schoolClassId" placeholder="请选择">
                        <el-option
                                v-for="item in schoolClass"
                                :key="item.class_id"
                                :label="item.classname"
                                :value="item.class_id">
                        </el-option>
                    </el-select>
                </div>
                <span slot="footer" class="dialog-footer" style="text-align: center">
                <div>
                    <el-button @click="classChangeF">转移</el-button><br>
                </div>
            </span>
            </el-dialog>

        </div>
    </div>
</template>
<script>
    import{
        getclassuser,
        batchaddclassuser,
        editclassusermarkname,
      delUser,
        delstudent,
      editUserMark,
        getschoolclass,
        changeclass
    }from'./../../api/exam_api'
    export default {
        data() {
            return{
                schoolClassId:'',
                schoolClass:[],
                changeClassDialog:false,
                userData:{
                    schoolInfo:{}
                },
                markname:'',
                editNoteLoading:false,
                editNoteDialog:false,
                input:'',
                classTable:[],
                currentPage4:1,
                classId:'',
                studentId:'',
                studentNumber:0,
                filters: {
                    pageSize: 10,
                    total: 0,
                    page: 1,
                },
                addUserDialog:false,
                btnLoading:false
            }
        },
        methods:{
            classChangeF(){
                let data={
                    student_id: this.studentId,
                    class_id:this.classId,
                    change_class_id:this.schoolClassId
                };
                changeclass(data).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            type: 'success',
                            message: res.msg
                        });
                        this.getClassUserList();
                        this.changeClassDialog=false;
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                });
            },
            getSchoolClass(row){
                this.studentId=row;
                getschoolclass().then((res)=>{
                    if(res.code==200){
                        this.schoolClass=res.data.classlist;
                        this.changeClassDialog=true;
                    }
                });
            },
            deletUser(studentId){
              // debugger;
                this.$confirm('移除后无法恢复，确定删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let _id = [];
                  _id.push(studentId.id);
                  delUser({id:_id}).then((res)=>{
                        if(res.code == 200 || res.code == 0){
                            this.$message({
                                type: 'success',
                                message: '移除成功'
                            });
                            this.getClassUserList();
                            this.userData.schoolInfo.usedNum--;
                        }else{
                            this.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    });
                })
            },
            //修改备注姓名
            editNote(studentId){
                if(studentId!=-1){
                    this.editStudentId=studentId
                }
                if(this.editNoteDialog){
                    this.editNoteLoading=true;
                    let data={
                        class_id:this.classId,
                        id:this.editStudentId,
                        markName:this.markname
                    };
                  editUserMark(data).then((res)=>{
                        if(res.code==200 || res.code == 0){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.editNoteDialog=false;
                            this.markname='';
                            this.editNoteLoading=false;
                            this.getClassUserList(this.classId);
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                            this.editNoteLoading=false;
                        }
                    });
                }else{
                    this.editNoteDialog=true;
                }
            },
            pageSizeChange(val){
                this.filters.pageSize = val;
                this.getClassUserList()
            },
            pageChange(val){
                this.filters.page = val;
                this.getClassUserList()
            },
            getClassUserList(){
                let data={
                    classId:this.classId,
                    page:this.filters.page,
                    perPage:this.filters.pageSize
                }
                getclassuser(data).then((res)=>{
                    if(res.code==200 || res.code == 0){
                        this.classTable=res.data.data;
                        this.classTable.forEach(function(index,i){
                            this.classTable[i].addTime=this.GLOBAL.request.toTime(index.addTime * 1000,2)
                        }.bind(this));
                        this.studentNumber=res.data.data.length;
                        this.filters.total=res.data.total;
                        // setTimeout(()=>{
                        //     this.userData=studentNum;
                        // },150)
                    }
                });
            },
            addUser(){
                let data={
                    classId:this.classId,
                    num:this.input,
                  pid:this.GLOBAL.pid
                };
                batchaddclassuser(data).then((res)=>{
                    this.btnLoading=true;
                    if(res.code==200 || res.code == 0){
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.getClassUserList();
                        parseInt(this.GLOBAL.userInfo.schoolInfo.usedNum);
                        this.GLOBAL.userInfo.schoolInfo.usedNum+= parseInt(this.input);
                        this.input='';
                        this.addUserDialog=false;
                        this.btnLoading=false;
                    }else{
                        this.btnLoading=false;
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });
            }
        },
        mounted(){
            this.classId=this.$route.query.plan;
            this.getClassUserList();
          this.userData=this.GLOBAL.userInfo;
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/ClassMember.vue